import { useEffect, useRef, useState } from 'react';
import { grabaProyectosBySiniestro, recuperaProyectosDeSiniestro } from '../../services/Siniestro/SiniestroService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Divider } from 'primereact/divider';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

const AsociarProyecto = ({ datSiniestro, funcSalir }) => {
    const [seleccionados, setSeleccionados] = useState([]);
    const [disponibles, setDisponibles] = useState([]);
    const [guarda, setGuarda] = useState(false);

    const asocToast = useRef();

    useEffect(() => {
        const recuperaProyectos = async () => {
            if (datSiniestro?.siniestroId) {
                try {
                    const datos = await recuperaProyectosDeSiniestro(datSiniestro?.siniestroId);
                    //console.log('DATOS REGRESADOS....', datos);
                    const iniSelect = datos.filter((item) => item.seleccion === true);
                    const iniDispo = datos.filter((item) => item.seleccion === false);
                    setSeleccionados(iniSelect);
                    setDisponibles(iniDispo);
                } catch (error) {
                    console.error('Error al recuperar Proyectos');
                }
            }
        };
        recuperaProyectos();
    }, [datSiniestro?.siniestroId]);

    // filtro para Disponibles
    const [filtrosDispo, setFiltrosDispo] = useState({
        global: { value: null, matchMode: 'contains' },
        clienteNombre: { value: null, matchMode: 'contains' },
        proyectoNombre: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltrosDispo, setValoresFiltrosDispo] = useState({
        clienteNombre: '',
        proyectoNombre: '',
        global: ''
    });

    // filtro para Texto
    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosDispo[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosDispo((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosDispo };
                        newFilters[field].value = nuevoValor;
                        setFiltrosDispo(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    // filtro para Seleccionados
    const [filtrosSel, setFiltrosSel] = useState({
        global: { value: null, matchMode: 'contains' },
        clienteNombre: { value: null, matchMode: 'contains' },
        proyectoNombre: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltrosSel, setValoresFiltrosSel] = useState({
        clienteNombre: '',
        proyectoNombre: '',
        global: ''
    });

    // filtro para Texto
    const textoFilterTemplateSel = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosSel[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosSel((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosDispo };
                        newFilters[field].value = nuevoValor;
                        setFiltrosSel(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    const marcarProyecto = (rowData) => {
        //
        setDisponibles((prev) => prev.filter((item) => item.proyectoId !== rowData.proyectoId));
        setSeleccionados((prev) => [...prev, { ...rowData, seleccion: true }]);
    };

    const desmarcarProyecto = (rowData) => {
        //
        setSeleccionados((prev) => prev.filter((item) => item.proyectoId !== rowData.proyectoId));
        setDisponibles((prev) => [...prev, { ...rowData, seleccion: false }]);
    };

    const templateSeleccionBody = (rowData) => <Checkbox onChange={() => desmarcarProyecto(rowData)} checked={true} />;
    const templateDisponibleBody = (rowData) => <Checkbox onChange={() => marcarProyecto(rowData)} checked={false} />;

    const handleGuardar = async () => {
        try {
            setGuarda(true);
            const lstProyectosIds = seleccionados.map((item) => item.proyectoId);
            const salida = await grabaProyectosBySiniestro(datSiniestro?.siniestroId, lstProyectosIds);
            if (salida === 'OK') {
                asocToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se han actualizado las realciones'
                });
            }
        } catch (error) {
            //console.error('ERROR: No se ha podido guardar')
            asocToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se han guardado las relaciones'
            });
        } finally {
            setGuarda(false);
            funcSalir();
        }
    };

    return (
        <div className="card">
            <Toast ref={asocToast} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-3 mb-3">
                    <label>Descripción del Evento: </label>
                </div>
                <div className="field col-9 mb-3">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {datSiniestro?.descripcion}
                    </span>
                </div>
                <div className="field col-5 mb-3">
                    <h5>Proyectos asociados</h5>
                    <DataTable
                        value={seleccionados}
                        emptyMessage="No hay Proyectos seleccionados"
                        showGridlines
                        size="small"
                        tableStyle={{ tableLayout: 'fixed', minWidth: '40rem' }}
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 20]}
                        responsiveLayout="scroll"
                        filters={filtrosSel}
                        filterDisplay="row"
                    >
                        <Column header="Check" body={templateSeleccionBody} style={{ width: '10%' }} />
                        <Column
                            header="Cliente"
                            field="clienteNombre"
                            style={{ width: '35%' }}
                            filter
                            filterPlaceholder="Filtro Cliente"
                            filterElement={(options) => textoFilterTemplateSel(options, 'clienteNombre')}
                            showFilterMenu={false}
                        />
                        <Column
                            header="Proyecto"
                            field="proyectoNombre"
                            style={{ width: '55%' }}
                            filter
                            filterPlaceholder="Filtro Cliente"
                            filterElement={(options) => textoFilterTemplateSel(options, 'proyectoNombre')}
                            showFilterMenu={false}
                        />
                    </DataTable>
                </div>
                <div className="field col-1 mb-3">
                    <Divider layout="vertical" />
                </div>
                <div className="field col-5 mb-3">
                    <h5>Proyectos Disponibles</h5>
                    <DataTable
                        value={disponibles}
                        emptyMessage="No hay Proyectos disponibles"
                        showGridlines
                        size="small"
                        tableStyle={{ tableLayout: 'fixed', minWidth: '40rem' }}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 300]}
                        responsiveLayout="scroll"
                        filters={filtrosDispo}
                        filterDisplay="row"
                    >
                        <Column header="Check" body={templateDisponibleBody} style={{ width: '10%' }} />
                        <Column
                            header="Cliente"
                            field="clienteNombre"
                            style={{ width: '35%' }}
                            filter
                            filterPlaceholder="Filtro Cliente"
                            filterElement={(options) => textoFilterTemplate(options, 'clienteNombre')}
                            showFilterMenu={false}
                        />
                        <Column
                            header="Proyecto"
                            field="proyectoNombre"
                            style={{ width: '55%' }}
                            filter
                            filterPlaceholder="Filtro Proyecto"
                            filterElement={(options) => textoFilterTemplate(options, 'proyectoNombre')}
                            showFilterMenu={false}
                        />
                    </DataTable>
                </div>
                <div className="field col-10 mb-3">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-2 mb-3">
                    <Button label="Guardar" icon="pi pi-save" onClick={handleGuardar} loading={guarda} />
                </div>
            </div>
        </div>
    );
};

export default AsociarProyecto;
